.wrapper {
  background-color: hsla(0, 0%, 100%, .85);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  border-radius: 8px;
  display: flex;
  flex: 1;
  height: 110px;
  justify-content: space-between;
  align-items: center;
}

.logo {
  height: 28px;
  padding-left: 1.5rem;
}

.left {
  display: flex;
  align-items: center;
  height: 100%;
  padding-right: 1.5rem;
  border-right: solid 1px rgba(0, 0, 0, .08);
}

.center {

}

.rightWrapper {
  display: flex;
  height: 100%;
}

.right {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.right > div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 50%;
  padding: 0 1.5rem;
  border-left: solid 1px rgba(0, 0, 0, .08);
}

.right > div:first-child {
  border-bottom: solid 1px rgba(0, 0, 0, .08);
}

.link {
  font-family: Aeroport;
  font-size: 0.9rem;
  color: var(--text-dark);
}

.link:hover {
  color: var(--text-dark) !important;
}
